import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const downloadRoutes = {
  [ERouteMappingKeys.DOWNLOAD]: {
    id: "download",
    path: "/download",
    components: {
      [BASE_PATH]: lazy(() => import("pages/Sections/Download/LandingPage")),
      "app/wifiman-desktop": lazy(
        () => import("pages/Sections/Download/Wifiman"),
      ),
      "app/identity-desktop": lazy(
        () => import("pages/Sections/Download/Identity"),
      ),
      "app/identity-ios": lazy(
        () => import("pages/Sections/Download/Identity/Mobile/Apple"),
      ),
      "app/identity-android": lazy(
        () => import("pages/Sections/Download/Identity/Mobile/Android"),
      ),
      "unifi/download-started": lazy(() =>
        import("pages/Sections/DownloadStarted/DownloadStarted").then((p) => ({
          default: p.DownloadStarted,
        })),
      ),
      "software/:slug": lazy(
        () => import("pages/Sections/Download/ProductDownloadsPage"),
      ),
      "releases/:slug": lazy(
        () => import("pages/Sections/Download/PastReleasesPage"),
      ),
      ":productGroupId": lazy(
        () => import("pages/Sections/Download/ProductGroupDownloadsPage"),
      ),
    },
  },
};
